import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-button">← back to home</Link>
        
        <h1>Privacy Policy</h1>
        <p className="company-name">Plaza Tech Software LLC</p>
        <p className="last-updated">Last updated: January 2026</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Plaza Tech Software LLC ("we", "us", "our") respects your privacy and is committed to 
            protecting your personal data.
          </p>
          <p>This Privacy Policy explains how we collect, use, and protect your information.</p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <p>We may collect:</p>
          <ul>
            <li>Name and email address</li>
            <li>Billing information (processed by Stripe)</li>
            <li>IP address and device information</li>
            <li>Usage data and analytics</li>
            <li>Account and login information</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Data</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Provide and operate our services</li>
            <li>Process payments</li>
            <li>Improve product performance</li>
            <li>Provide customer support</li>
            <li>Communicate service updates</li>
          </ul>
        </section>

        <section>
          <h2>Payments</h2>
          <p>Payments are processed by Stripe. We do not store your credit card details.</p>
          <p>
            Stripe Privacy Policy: <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">
              https://stripe.com/privacy
            </a>
          </p>
        </section>

        <section>
          <h2>Cookies & Analytics</h2>
          <p>We use cookies and analytics tools to improve user experience and service performance.</p>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>We use industry-standard security measures to protect your data.</p>
        </section>

        <section>
          <h2>Data Retention</h2>
          <p>
            We retain personal data only as long as necessary to provide our services or comply with 
            legal obligations.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You may request:</p>
          <ul>
            <li>Access to your data</li>
            <li>Correction of inaccurate data</li>
            <li>Deletion of your data</li>
          </ul>
          <p className="contact-info">
            Email: <a href="mailto:dan@plaza.tech">dan@plaza.tech</a>
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Plaza Tech Software LLC<br />
            131 Continental Dr, Suite 305<br />
            Newark, DE 19713<br />
            USA
          </p>
          <p className="contact-info">
            📧 <a href="mailto:dan@plaza.tech">dan@plaza.tech</a>
          </p>
        </section>
      </div>
    </div>
  );
}


